import { FormControl } from '@angular/forms';

export enum EnquiryType {
    CONTACT = 'CONTACT',
    ADVANCED_ABACUS = 'ADVANCED_ABACUS',
    HANDWRITING_IMPROVEMENT = 'HANDWRITING_IMPROVEMENT',
    SPOKEN_ENGLISH = 'SPOKEN_ENGLISH',
    VEDIC_MATHS = 'VEDIC_MATHS',
    MONTESSORI_TEACHER_TRAINING = 'MONTESSORI_TEACHER_TRAINING',
    DIPLOMA_MONTESSORI_PRIMARY = 'DIPLOMA_MONTESSORI_PRIMARY',
    DIPLOMA_MONTESSORI_ELEMENTARY = 'DIPLOMA_MONTESSORI_ELEMENTARY'
}

export interface EnquiryRequest {
    name: string;
    email: string;
    phone: string;
    cityAndState: string;
    message?: string | null;
    type: EnquiryType;
}

export interface EnquiryForm {
    name: FormControl<string | null>;
    email: FormControl<string | null>;
    phone: FormControl<string | null>;
    cityAndState: FormControl<string | null>;
    message: FormControl<string | null>;
}

export interface FranchiseEnquiryRequest {
    name: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    pincode: string;
    occupation: string;
    experience: string;
    preferredLocation: string;
    hasSpace: string;
    investmentBudget: string;
    programInterests: string[];
}
